var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import useCheckboxes from "../../Hooks/useCheckboxes";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import PipelineService from "../../../Services/Pipeline.service";
const PAGE_SIZE = 20;
const SEARCH_DEFAULT = "";
const DEFAULT_SEARCH = {
    query: SEARCH_DEFAULT,
};
const OpportunityAssigneeLookup = ({ selected: selectedAssignees, children, pipelineId }) => {
    var _a;
    const [query, setQuery] = React.useState(SEARCH_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const searchItems = () => {
        setSearchArgs({
            query,
        });
    };
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedAssignees || [],
        equalsFunc: (a, b) => a.personId === b.personId,
    });
    const { table, dataState } = usePagedSortedTable({
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getData: (sort, page, sArgs) => __awaiter(void 0, void 0, void 0, function* () {
            return PipelineService.getApplicableAssignees(Object.assign({ 
                // @ts-expect-error - TS2783 - 'query' is specified more than once, so this usage will be overwritten.
                query: sArgs.query, pipelineId }, sArgs), {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
            });
        }),
        searchArgs,
        getNumPages: (result) => 
        // $FlowFixMe inconsequential error.
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No Assignees found",
        columnsThatCantSort: [0, 1],
        columns: [
            {
                title: "Institution ID",
                size: 1,
            },
            {
                title: "Name",
                size: 2,
            },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => data.map((assignee) => [
            assignee.studentId,
            assignee.fullName,
        ]),
    });
    return children({
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        lookup: (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "opportunityAssigneeSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "opportunityAssigneeSearch", placeholder: "Search Name", style: { width: 200 }, value: query, onChange: (event) => {
                                        setQuery(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx(AlertInfo, { message: "Only up to 20 people can be selected for the assignee pool." }), _jsx("hr", {}), table] })),
    });
};
export default OpportunityAssigneeLookup;
